module.exports = __webpack_public_path__ + "media/images/header-bullet-882457e13257a34239cbd07152726f07.png";